module.exports = __webpack_public_path__ + "img/hidden09.30bd5faa.jpg";